/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Vráceno`
};

const da_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Refunderet`
};

const de_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Erstattet`
};

const en_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Refunded`
};

const es_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Reembolsado`
};

const fr_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Remboursé`
};

const hu_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Visszatérítve`
};

const it_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Rimborsato`
};

const nl_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Terugbetaald`
};

const pl_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Zwrócono`
};

const pt_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Reembolsado`
};

const sv_refunded = /** @type {(inputs: {}) => string} */ () => {
	return `Återbetald`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refunded = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refunded(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refunded", locale)
	if (locale === "cs") return cs_refunded(inputs)
	if (locale === "da") return da_refunded(inputs)
	if (locale === "de") return de_refunded(inputs)
	if (locale === "en") return en_refunded(inputs)
	if (locale === "es") return es_refunded(inputs)
	if (locale === "fr") return fr_refunded(inputs)
	if (locale === "hu") return hu_refunded(inputs)
	if (locale === "it") return it_refunded(inputs)
	if (locale === "nl") return nl_refunded(inputs)
	if (locale === "pl") return pl_refunded(inputs)
	if (locale === "pt") return pt_refunded(inputs)
	return sv_refunded(inputs)
};